<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p17"><span><a href="#/Contents#rp17">ORIENTAL STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>A light, fragrant stock that can be used in Asian soups and entrées.</i></span></p>
<p class="make"><span>Makes about 2 quarts</span></p>
<p class="hang"><span>8 cups water</span></p>
<p class="hang"><span>6 cups shredded bok choy or Chinese cabbage</span></p>
<p class="hang"><span>1¼ cups loosely packed cilantro, coarsely chopped</span></p>
<p class="hang"><span>1 each: sliced large onion, carrot, small red bell pepper</span></p>
<p class="hang"><span>⅓ cup sliced gingerroot</span></p>
<p class="hang"><span><a id="page_13"></a>1 tablespoon minced garlic</span></p>
<p class="hang"><span>3 dried shiitake mushrooms</span></p>
<p class="hang"><span>4 teaspoons reduced-sodium tamari soy sauce</span></p>
<p class="hang"><span>2 star anise</span></p>
<p class="hang"><span>2 teaspoons five-spice powder</span></p>
<p class="hang"><span>1½ teaspoons toasted Szechuan peppercorns</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients, except salt and pepper, to boiling in Dutch oven; reduce heat and simmer, covered, 1 hour. Strain, discarding vegetables and seasonings; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 8</span></p>
<p class="per1"><span>% calories from fat: 11</span></p>
<p class="per1"><span>Protein (g): 0.6</span></p>
<p class="per1"><span>Carbohydrate (g): 1.1</span></p>
<p class="per1"><span>Fat (g): 0.1</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 110</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0117.vue?82ff5a18